module.exports = __webpack_public_path__ + "img/help_logo.1a2437dd.png";